module.exports = __webpack_public_path__ + "img/btn_color.81766254.svg";